"use client";

import { c as _c } from "react/compiler-runtime";
import { Form, TextHeading } from "@opensea/ui-kit";
import { useForm } from "react-hook-form";
import { useTranslations } from "use-intl";
import { AuthCode } from "../../../components/AuthCode";
export function CodeInputStep(t0) {
  const $ = _c(23);
  const {
    onSubmit
  } = t0;
  const t = useTranslations("wallet.CodeInputStep");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: {
        code: ""
      },
      mode: "onBlur"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    register,
    handleSubmit,
    setValue
  } = useForm(t1);
  let t2;
  if ($[1] !== handleSubmit || $[2] !== onSubmit) {
    t2 = handleSubmit(onSubmit);
    $[1] = handleSubmit;
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("enterCode");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <TextHeading asChild={true} className="mb-6 block" size="md"><label htmlFor="connect-embedded-wallet-code-input">{t3}</label></TextHeading>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== register) {
    t5 = register("code", {
      required: true,
      minLength: 6,
      maxLength: 6
    });
    $[8] = register;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== setValue) {
    t6 = value => setValue("code", value);
    $[10] = setValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== handleSubmit || $[13] !== onSubmit) {
    t7 = () => handleSubmit(onSubmit)();
    $[12] = handleSubmit;
    $[13] = onSubmit;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <AuthCode id="connect-embedded-wallet-code-input" {...t5} onChange={t6} onComplete={t7} />;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t4 || $[21] !== t8) {
    t9 = <Form onSubmit={t2}>{t4}{t8}</Form>;
    $[19] = t2;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}